/**
 * Labstep
 *
 * @module core/Input/Async
 * @desc Input that saves its value async
 */

import React from 'react';
import { Input } from 'semantic-ui-react';
import type { IAsyncInputProps } from './types';

let timeout: NodeJS.Timeout | null = null;
const debounceTime = 500;

export const async = <TValue extends string>(
  func: (value: TValue) => void,
  value: TValue,
) => {
  if (timeout) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(() => {
    func(value);
  }, debounceTime);
};

export class AsyncInput extends React.Component<IAsyncInputProps> {
  constructor(props: IAsyncInputProps) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(evt: React.ChangeEvent<HTMLInputElement>) {
    const { value } = evt.target;
    async(this.props.onChange, value);
  }

  render() {
    const { onChange, inputRef, ...rest } = this.props;

    return (
      <Input
        ref={inputRef}
        fluid
        {...rest}
        onChange={this.onChange}
      />
    );
  }
}
